import navbarSearchAndPinList from '@/layouts/components/navbar/navbarSearchAndPinList';
import themeConfig from '@/../themeConfig';

// Remember the "Show legacy menus" preference across sessions.
const readShowLegacyMenus = () => {
  try {
    return localStorage.getItem('showLegacyMenus') === 'true';
  } catch (e) {
    return false;
  }
};

const state = {
  // AppActiveUser: {
  //   guid: null,
  //   id: null,
  //   first_name: null,
  //   last_name: null,
  //   email: null,
  //   mobile: null,
  //   last_login: null,
  //   subscriptions: [],
  //   roles: []
  // },
  // getUserPromise: null,
  // rules: [],
  AppActiveUserNavMenu: [],
  bodyOverlay: false,
  isVerticalNavMenuActive: true,
  mainLayoutType: themeConfig.mainLayoutType || 'vertical',
  navbarSearchAndPinList,
  reduceButton: themeConfig.sidebarCollapsed,
  verticalNavMenuWidth: 'default',
  verticalNavMenuItemsMin: false,
  scrollY: 0,
  showLegacyMenus: readShowLegacyMenus(),
  starredPages: navbarSearchAndPinList.data.filter((page) => page.highlightAction),
  theme: themeConfig.theme || 'light',
  themePrimaryColor: themeConfig.colors.primary,
  unreadNotifications: [],
  // routeRoles: {
  //   systemAdmin: ['SuperAdmin', 'SystemAdmin'],
  //   systemUser: [
  //     'DataAdmin',
  //     'DesignAdmin',
  //     'Reseller',
  //     'DataProcessor',
  //     'DataProcessor',
  //     'FengShuiProcessor',
  //     'TrainingAdmin',
  //     'Blogger',
  //     'FinanceUser'
  //   ],
  //   salesUser: ['CustomerSuccess', 'SalesManager', 'SalesUser'],
  //   member: ['Member'],
  //   guest: ['Guest']
  // },
  // userLoaded: false,
  // Can be used to get current window with
  // Note: Above breakpoint state is for internal use of sidebar & navbar component
  windowWidth: null
};

export default state;
